import { render, staticRenderFns } from "./MisEventos.vue?vue&type=template&id=248b746f&scoped=true&"
import script from "./MisEventos.vue?vue&type=script&lang=js&"
export * from "./MisEventos.vue?vue&type=script&lang=js&"
import style0 from "./MisEventos.vue?vue&type=style&index=0&id=248b746f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248b746f",
  null
  
)

export default component.exports